import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import ProductRouter from './components/ProductRouter';
import './styles/index.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/producto/:productId" element={<ProductRouter />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
